var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins } from "vue-property-decorator";
import { Notification } from "@/common/services/notificationService";
import { Focusable } from "@/common/mixins/Focusable";
import { RecordState } from "@/common/types/RecordState";
import { DecisionState } from "@/common/types/DecisionState";
import RouteService from "@/common/services/routeService";
import EntityService from "@/common/services/EntityService";
import PdfService from "@/common/services/PdfService";
import TextLabelRow from "@/common/components/TextLabelRow.vue";
import OrganisationYearlyReportFeedbackView from "@/template/components/feedback/OrganisationYearlyReportFeedbackView.vue";
import AccountNumberRequestFeedbackView from "@/template/components/feedback/AccountNumberRequestFeedbackView.vue";
import PaymentRequestExpenseReportFeedbackView from "@/template/components/feedback/PaymentRequestExpenseReportFeedbackView.vue";
import AidProposalView from "@/template/components/feedback/AidProposalView.vue";
import AidDecisionView from "@/template/components/feedback/AidDecisionView.vue";
import RefundFeedbackView from "@/template/components/feedback/RefundFeedbackView.vue";
import InvestmentReportFeedbackView from "@/template/components/feedback/InvestmentReportFeedbackView.vue";
import DeadlineChangeFeedbackView from "@/template/components/feedback/DeadlineChangeFeedbackView.vue";
import PurposeChangeFeedbackView from "@/template/components/feedback/PurposeChangeFeedbackView.vue";
import TargetChangeFeedbackView from "@/template/components/feedback/TargetChangeFeedbackView.vue";
import SummaryReportFeedbackView from "@/template/components/feedback/SummaryReportFeedbackView.vue";
var FeedbackView = /** @class */ (function (_super) {
    __extends(FeedbackView, _super);
    function FeedbackView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityService = new EntityService();
        return _this;
    }
    Object.defineProperty(FeedbackView.prototype, "pdfService", {
        get: function () {
            var config = this.$store.getters["vuexPageModule/configuration"];
            var printAsHtml = config.featureConfiguration.printAsHTML;
            return new PdfService(printAsHtml);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOADING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "downloadingPdf", {
        get: function () {
            return this.$store.state.vuexPageModule.downloadingPdf;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_DOWNLOADING_PDF", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "updating", {
        get: function () {
            return this.$store.state.vuexPageModule.updating;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_UPDATING", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "model", {
        get: function () {
            return this.$store.state.vuexPageModule.recordable;
        },
        set: function (recordable) {
            this.$store.commit("vuexPageModule/SET_RECORDABLE", recordable);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "record", {
        get: function () {
            return this.model.record;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "recordableType", {
        get: function () {
            var type = this.$route.meta.recordableType;
            if (type) {
                return type;
            }
            else {
                console.error("Feedback route 'recordableType' is not defined.");
                throw new Error("Feedback route 'recordableType' is not defined.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "apiType", {
        get: function () {
            var type = this.$route.meta.type;
            if (type) {
                return type;
            }
            else {
                console.error("Feedback route 'type' is not defined.");
                throw new Error("Feedback route 'type' is not defined.");
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isAidTargetYearlyReportFeedback", {
        get: function () {
            return this.apiType == "AidTargetYearlyReportFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isOrganisationYearlyReportFeedback", {
        get: function () {
            return this.apiType == "OrganisationYearlyReportFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isAidProposal", {
        get: function () {
            return this.apiType == "AidProposal";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isAidDecision", {
        get: function () {
            return this.apiType == "AidDecision";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isAccountNumberRequestFeedback", {
        get: function () {
            return this.apiType == "AccountNumberRequestFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isExpandedStrategyAndBudgetaryEstimateFeedback", {
        get: function () {
            return this.apiType == "ExpandedStrategyAndBudgetaryEstimateFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isPaymentPlanFeedback", {
        get: function () {
            return this.apiType == "PaymentPlanFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isPaymentRequestExpenseReportFeedback", {
        get: function () {
            return this.apiType == "PaymentRequestExpenseReportFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isRefundFeedback", {
        get: function () {
            return this.apiType == "RefundRequestFeedback" || this.apiType == "ClaimForRecoveryFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isInvestmentReportFeedback", {
        get: function () {
            return this.apiType == "InvestmentReportFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isDeadlineChangeFeedback", {
        get: function () {
            return this.apiType == "DeadlineChangeFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isPurposeChangeFeedback", {
        get: function () {
            return this.apiType == "PurposeChangeFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isTargetChangeFeedback", {
        get: function () {
            return this.apiType == "TargetChangeFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "isSummaryReportFeedback", {
        get: function () {
            return this.apiType == "SummaryReportFeedback";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "fetchFailedKey", {
        get: function () {
            if (this.isAidProposal)
                return "Feedback.AidApplication.AidProposal.FetchFailed";
            else if (this.isAidDecision)
                return "Feedback.AidApplication.AidDecision.FetchFailed";
            else
                return "Feedback.FetchFailed";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "routeService", {
        get: function () {
            return new RouteService(this.$router);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "currentUser", {
        get: function () {
            return this.$store.state.vuexPageModule.currentUser;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "hasProcuration", {
        get: function () {
            return this.currentUser.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "title", {
        get: function () {
            var titlePath = this.$route.meta.title;
            return this.$t(titlePath).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "decisionStateStr", {
        get: function () {
            if (!this.model || !this.model.record)
                return null;
            if (this.isOrganisationYearlyReportFeedback && this.model.record.decisionState === DecisionState.Approved)
                return this.$t("Feedback.Ready").toString();
            if (this.isAidTargetYearlyReportFeedback) {
                if (this.model.record.decisionState === DecisionState.ClosedWithoutResult)
                    return this.$t("Enums.DecisionState." + this.model.record.decisionState).toString();
                else
                    return this.$t("Feedback.Ready").toString();
            }
            return this.$t("Enums.DecisionState." + this.model.record.decisionState).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeedbackView.prototype, "allowMarkAsRead", {
        get: function () {
            return (this.record.state === RecordState.DecisionGiven || this.record.state === RecordState.ProposalGiven);
        },
        enumerable: false,
        configurable: true
    });
    FeedbackView.prototype.created = function () {
        this.recordId = this.$route.params.id;
    };
    FeedbackView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1, error;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, this.entityService.getRecordable(this.recordableType, this.recordId)];
                    case 1:
                        _a.model = _b.sent();
                        if (!this.canAutoMarkAsReady()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.markAsRead()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        this.loading = false;
                        this.$nextTick(function () {
                            _this.focusOnFirstTag("h1");
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        console.error(e_1);
                        this.loading = false;
                        error = this.$t(this.fetchFailedKey);
                        Notification.error(this, error);
                        this.routeService.goToFrontPage();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FeedbackView.prototype.canAutoMarkAsReady = function () {
        return this.hasProcuration /* current user must be a procurator */
            && (this.model.canBeAcknowledged || this.allowMarkAsRead); /* entity (in its current state) must support acknowledgement OR be in correct state*/
    };
    FeedbackView.prototype.beforeRouteLeave = function (to, from, next) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$store.dispatch("vuexPageModule/clean")];
                    case 1:
                        _a.sent();
                        next();
                        return [2 /*return*/];
                }
            });
        });
    };
    FeedbackView.prototype.generatePdf = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.downloadingPdf = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.pdfService.generatePdf(this.apiType, this.recordId, this.languageCode)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        error = this.$t("PdfError");
                        Notification.error(this, error);
                        console.error(error, e_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.downloadingPdf = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    FeedbackView.prototype.markAsRead = function (onSuccessGoToHistory) {
        if (onSuccessGoToHistory === void 0) { onSuccessGoToHistory = false; }
        return __awaiter(this, void 0, void 0, function () {
            var markOk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.updating == true)) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        this.updating = true;
                        return [4 /*yield*/, this.entityService.markAsRead(this.recordableType, this.recordId)];
                    case 2:
                        markOk = _a.sent();
                        if (markOk) {
                            Notification.success(this, this.$t("Notification.MarkAsReadSuccess").toString());
                            if (onSuccessGoToHistory) {
                                this.routeService.goToRecordHistory();
                            }
                        }
                        else {
                            Notification.error(this, this.$t("Notification.MarkAsReadFailed").toString());
                        }
                        this.updating = false;
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FeedbackView.prototype.getStringValue = function (value) {
        return value ? value.toString() : null;
    };
    Object.defineProperty(FeedbackView.prototype, "languageCode", {
        get: function () {
            return this.$store.state.vuexPageModule.language;
        },
        enumerable: false,
        configurable: true
    });
    FeedbackView = __decorate([
        Component({
            name: "FeedbackView",
            components: {
                TextLabelRow: TextLabelRow,
                OrganisationYearlyReportFeedbackView: OrganisationYearlyReportFeedbackView,
                AccountNumberRequestFeedbackView: AccountNumberRequestFeedbackView,
                PaymentRequestExpenseReportFeedbackView: PaymentRequestExpenseReportFeedbackView,
                AidProposalView: AidProposalView,
                AidDecisionView: AidDecisionView,
                RefundFeedbackView: RefundFeedbackView,
                InvestmentReportFeedbackView: InvestmentReportFeedbackView,
                DeadlineChangeFeedbackView: DeadlineChangeFeedbackView,
                PurposeChangeFeedbackView: PurposeChangeFeedbackView,
                TargetChangeFeedbackView: TargetChangeFeedbackView,
                SummaryReportFeedbackView: SummaryReportFeedbackView
            }
        })
    ], FeedbackView);
    return FeedbackView;
}(Mixins(Focusable)));
export default FeedbackView;
